<template>
    <DashboardLayout>
        <div class="grid flex flex-column justify-content-center align-items-center min-h-screen gap-4">
            <span class="Paragraph-Regular text-center">
                This is a temporary page. Use this page to view tutor profiles.
            </span>

            <div v-for="t in tutors" :key="t._id">
                <Button class="orange-button" @click="openProfile(t._id)">{{ t.username }} - Click to view
                    profile</Button>
            </div>

            <span class="Paragraph-Regular text-center" v-if="tutors.length < 1">
                Seems there are no verified tutors yet.
            </span>

        </div>
    </DashboardLayout>
</template>

<script setup>
import DashboardLayout from "@/layout/DashboardLayout.vue";
import { fetchPublicProfiles } from '@/api/tutor';
import router from '@/router';
import { Button } from 'primevue';
import { onMounted, ref } from 'vue';

const tutors = ref([]);
const openProfile = (id) => {
    router.push('/tutorProfile/' + id);
}
onMounted(async () => {
    try {
        const profiles = await fetchPublicProfiles();
        tutors.value = profiles.data.data.tutors;
    } catch {
        tutors.value = [];
    }
})
</script>